export default "__VITE_ASSET__b8b59176__"